import { createTheme } from '@mui/material_v7/styles';

// TODO: Khrystyna should provide theme colors instead of rgba
const shadowsTheme = createTheme({
  shadows: [
    'none', // 0
    '0px 0.25px 1px 0px rgba(0, 0, 0, 0.04), 0px 0.5px 2px 0px rgba(0, 0, 0, 0.20)', // 1
    '0px 0.5px 2px 0px rgba(0, 0, 0, 0.04), 0px 1px 4px 0px rgba(0, 0, 0, 0.20)', // 2
    'none',
    'none',
    'none',
    '0px 0.5px 6px 0px rgba(0, 0, 0, 0.04), 0px 4px 12px 0px rgba(0, 0, 0, 0.20)', // 6
    'none',
    'none',
    'none',
    'none',
    'none',
    '0px 4px 12px 0px rgba(0, 0, 0, 0.04), 0px 8px 24px 0px rgba(0, 0, 0, 0.20)', // 12
    'none',
    'none',
    'none',
    '0px 6px 16px 0px rgba(0, 0, 0, 0.04), 0px 10px 32px 0px rgba(0, 0, 0, 0.20)', // 16
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    'none',
    '0px 24px 36px 0px rgba(0, 0, 0, 0.12), 0px 8px 48px 0px rgba(0, 0, 0, 0.12)', // 24
  ],
});

export default shadowsTheme;
